export const getActiveLanguageCode = (language) => {
  const activeLanguage = language || localStorage.getItem("i18nextLng") || "en";
  return activeLanguage === "vietnam" || activeLanguage === "vi" ? "vi" : "en";
};

export const getLocalizedTitle = (item, language) => {
  const title =
    item?.title ??
    item?.name ??
    item?.serviceName ??
    item?.serviceItemName ??
    item?.label ??
    item;
  if (!title) return "";
  if (typeof title === "string") return title;

  const languageCode = getActiveLanguageCode(language);
  return title[languageCode] || title.en || title.vi || title.value || "";
};
